// Counter
$('.elem-counter').each(function () {
  var counter = $(this);
  var min = counter.find('.js-btn-minus');
  var plus = counter.find('.js-btn-plus');
  var input = counter.find('input');

  min.click(function () {
    var num = parseInt(input.val());

    if (num > 1) {
      num--;
      input.val(num);
    }
  });

  plus.click(function () {
    var num = parseInt(input.val());

    if (num < 999) {
      num++;
      input.val(num);
    }
  });
});